import React from 'react';
import { useSelector } from 'react-redux';
import { T } from 'shared/helper/translate';
import RubriqAbstractStatus from './RubriqAbstractStatus';
var RubriqAbstractHeader = function RubriqAbstractHeader(_ref) {
  var onSubmitAbstract = _ref.onSubmitAbstract,
    _ref$loadingCheckDocu = _ref.loadingCheckDocumentModal,
    loadingCheckDocumentModal = _ref$loadingCheckDocu === void 0 ? false : _ref$loadingCheckDocu;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    abstract = _useSelector.abstract;
  var documents = (abstract === null || abstract === void 0 ? void 0 : abstract.abstracts) || [];
  var abstractCount = documents.length;
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom d-flex justify-content-between align-items-center py-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-muted"
  }, abstractCount === 1 ? /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-processed-singular"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-processed-plural",
    params: abstractCount
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2"
  }, /*#__PURE__*/React.createElement(RubriqAbstractStatus, null), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn btn-primary rounded-3",
    onClick: function onClick() {
      return onSubmitAbstract();
    },
    disabled: loadingCheckDocumentModal
  }, /*#__PURE__*/React.createElement(T, {
    source: "submit abstract"
  }))));
};
export default RubriqAbstractHeader;